import { BadgePercent } from 'lucide-react';
import { AppLink } from '@/shared/components/AppLink';

interface PdpAdditionalOfferProps {
  text: string | null | undefined;
  onTncClick?: () => void;
}

export function PdpAdditionalOffer({ text, onTncClick }: PdpAdditionalOfferProps) {
  const offerText = text?.trim();
  if (!offerText) return null;

  return (
    <div className="relative border-t border-dashed border-[#e2e2e2] px-5 py-2.5 md:px-0">
      <BadgePercent
        aria-hidden
        className="absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-[#e26a5e] md:left-0"
        strokeWidth={1.75}
      />
      <p className="pl-8 text-sm leading-snug text-[#333] md:pl-9">
        {offerText}{' '}
        <AppLink
          to="/tnc.html#offers"
          className="text-[var(--link-blue)] hover:underline"
          onClick={() => onTncClick?.()}
        >
          <sup>*</sup>TCA
        </AppLink>
      </p>
    </div>
  );
}
